/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairServiceCatalogV3 } from '../../models/finnair-service-catalog-v-3';

export interface GetServiceCatalogByOrderV3$Params {
  orderId: string;
  hash?: string;
  frontEndQuota?: boolean;
}

export function getServiceCatalogByOrderV3(http: HttpClient, rootUrl: string, params: GetServiceCatalogByOrderV3$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairServiceCatalogV3>> {
  const rb = new DapiRequestBuilder(rootUrl, getServiceCatalogByOrderV3.PATH, 'get');

  if (params) {
    rb.query('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('frontEndQuota', params.frontEndQuota, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairServiceCatalogV3>;
    }),
    catchErrorAsJson()
  );
}

getServiceCatalogByOrderV3.PATH = '/api/v3/services/order';
